export default "__VITE_ASSET__BDqU8CzH__"